import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class Request_se {
    constructor() {
        this.entity = 'requestUser';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        return Api.getById(this.entity, id)
    }


    getList(page_,size_,search,from,to,type) {
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("type",type)
        formData.append("from",from)
        formData.append("to",to)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/list',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/page',
            headers: {'Content-Type': 'application/json'},
        })
    }

    view(id) {

        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/view/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }
    save(text,uintId,userId) {
        let formData = new FormData();
        formData.set("text",text)
        formData.set("uintId",uintId)
        formData.set("userId",userId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/save/',
            headers: {'Content-Type': 'application/json'},
        })
    }
    response(uintId,userId,reqUserId) {
        let formData = new FormData();
        formData.set("uintId",uintId)
        formData.set("userId",userId)
        formData.set("reqUserId",reqUserId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/response/',
            headers: {'Content-Type': 'application/json'},
        })
    }

// ---------------------
    view_unit(id) {

        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/unitEditReport/view/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }
    response_unit(id) {
        let formData = new FormData();
        formData.set("id",id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/unitEditReport/response/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    report_unit(page_,size_,search,from,to,type) {
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search)
        formData.append("type",type)
        formData.append("from",from)
        formData.append("to",to)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/unitEditReport/list',
            headers: {'Content-Type': 'application/json'},
        })
    }

}
export default new Request_se();
